import ReferenceTable from "./ReferenceTable";
import FleetEmissionAnalytics from "./FleetEmissionAnalytics";
import FleetEmissionOverview from "./FleetEmissionOverview";
import FuelConsumption from "./FuelConsumption";
import KpiTrends from "./KpiTrends";
import FleetOverviewCalculations from "./FleetOverviewCalculations";
import MEFuelConsumption from "./MEFuelConsumption";
import RemainingFuel from "./RemainingFuel";
import MainEnginePower from "./MainEnginePower";
import SFOCEfficiency from "./SFOCEfficiency";

const FleetReference = () => {
  return (
    <div className="p-6 bg-white rounded-xl shadow-sm border border-gray-200">
      <ReferenceTable />
      <FleetOverviewCalculations />
      <FleetEmissionAnalytics />
      <FleetEmissionOverview />
      <FuelConsumption />
      <KpiTrends />
      {/* <MEFuelConsumption />
      <RemainingFuel />
      <MainEnginePower />
      <SFOCEfficiency /> */}
    </div>
  );
};

export default FleetReference;